$(() => {
    ///////////Burger Menu/////////////
    const $modalMenu = $("#modalmenu");
    $("#burger-toggle").on('click', function () {
        let $callMenu = $(this);
        if ($callMenu.hasClass("opened")) {
            $callMenu.attr("aria-expanded", "false");
            $callMenu.removeClass("opened");
            $modalMenu.slideUp();
            $("body").removeClass("menu-open");
        } else {
            $callMenu.attr("aria-expanded", "true");
            $callMenu.addClass("opened");
            $modalMenu.slideDown();
            $("body").addClass("menu-open");
        }
    });

    ///////////Accordion Menu/////////////
    let $accordionMenu = $(".sub-navigation-button")
    $accordionMenu.each( function () {
        let $this = $(this);
        $this.on("click", function(){
            // @ts-ignore
            let panel = $this[0].parentElement.nextElementSibling;
            if ($this.hasClass("active")) {
                $this.removeClass("active");
                $this.attr("aria-expanded", "false");
                // @ts-ignore
                $(panel).slideUp();
            } else {
                $this.addClass("active");
                $this.attr("aria-expanded", "true");
                // @ts-ignore
                $(panel).slideDown();
                var KEYCODE_ESC = 27;
                $(document).on("keyup", function (e) {
                    if (e.keyCode == KEYCODE_ESC && $this.hasClass("active")) {
                        $this.click();
                        $this.focus();
                    }
                });
            }
        })
    });

    /////////////Active Item Menu/////////////
    const pathname = String(window.location.pathname);
    const $itemsMenu = $("li.menu a");
    $itemsMenu.each(function () {
        let $this = $(this);
        let itemsMenuhref = String($this.prop('href'));
        if ((itemsMenuhref.includes(pathname) && pathname != "/" && pathname != "/en"))  {
            $this.addClass("is-active");
        } else {
            $this.removeClass("is-active");
        }
    });

    /////////////add class cta sub navigation/////////////
    const $subMenuNavigation = $("#main-menu li.menu button");
    $subMenuNavigation.parent().addClass("sub-menu-navigation");


});